export default function () {
  const $header = document.querySelector('.js-sticky-header');

  const headroom = new Headroom($header, {
    offset: 200,
  });

  headroom.init();
};



// WEBPACK FOOTER //
// ./assets/scripts/components/header.js